import React from 'react';
import { Divider } from 'antd';
import styles from './index.css'; 

export default (props) => (
<Divider className={styles.divider} style={Object.assign({
    background: '#f3f4f5', 
}, props.style)} {...props} />        
)



// WEBPACK FOOTER //
// ./src/component/divider/index.js